import React, { Component, Fragment } from 'react';
import { elements } from './_data_safety_layout';
import DayQualityElement from './DayQualityElement';
import '@app/components/sqdp/int/styles/quality-layout.css';
import dayjs from 'dayjs';
import { getDayColorError, getDayColorGood, getDayColorWarn } from '@app/services/localStorage.service';

class QualityLayout extends Component {
  state = {
    showInfo: false,
    element: {},
  };

  showInfo = (num) => {
    this.props.showIssueInfo(num, 2, 'int');
  };

  getColorOfDay = (issueOfDay, dateNum) => {
    if (!issueOfDay) return 'emtpy_state';

    const {
      isRestDay,
      countQualityTotal = 0,
      highestQualityProductionDownTimeMinutes = 0,
      highestQualityErrorProductNumber = 0,
    } = issueOfDay;

    const thisDay = dayjs().date(dateNum).day();

    // Ngày nghỉ cuối tuần
    if (isRestDay && (thisDay === 6 || thisDay === 0)) {
      return 'emtpy_state';
    }

    let today = dayjs();
    let selectedTime = dayjs(this.props.selectedMonth);
    if (
      today.get('month') <= selectedTime.get('month') &&
      today.get('year') <= selectedTime.get('year') &&
      dateNum > today.get('date')
    ) {
      return 'emtpy_state';
    }

    // 🔴 Có thời gian dừng sản xuất > 30 hoặc lỗi chất lượng cao > 3
    if (highestQualityProductionDownTimeMinutes > 30 || highestQualityErrorProductNumber > 3) {
      return 'red_state';
    }
    //🟢 Không dừng sản xuất và không lỗi chất lượng cao
    if (highestQualityProductionDownTimeMinutes === 0 && highestQualityErrorProductNumber === 0) {
      return 'green_state';
    }
    // 🟡 còn lại
    // (0 <  thời gian dừng sản xuất < 30 ) hoặc lỗi chất lượng cao
    return 'yellow_state';
  };

  populateElements = (start, end) => {
    let items = [];
    for (let i = start; i <= end; i++) {
      let issueOfDay = this.props.dataInMonth[i - 1];
      let color = this.getColorOfDay(issueOfDay, i);
      items.push(
        <DayQualityElement
          oneTypeIssue={this.props.oneTypeIssue}
          showInfo={this.showInfo}
          num={i}
          color={color}
          issues={issueOfDay}
          lastClickedElement={this.props.lastClickedElement}
          lastGroupClicked={this.props.lastGroupClicked}
        />,
      );
    }
    return items;
  };

  render() {
    return (
      // <div className="wrapper">
      <>
        <div id="table-quality">
          {/* Elements 1-4 */}
          {this.populateElements(1, 31)}
          {/* Information Table */}
          {/* {this.state.showInfo && (
            <Fragment>
              <div id="element-box" className={`${category}`}>
                <div className="number">{number}</div>
                <div className="symbol">{symbol}</div>
                <div className="element-name">{name}</div>
              </div>
              <div id="information">
                <div
                  onClick={this.closeInfo}
                  className="close-button"
                  title="Close Info"
                >
                  Close [&times;]
                </div>
                <div>
                  <h1 className="big_title">{name}</h1>
                  <span className={`cat_name ${category}`}>{category}</span>
                  {appearance && (
                    <div className="appearance">
                      <strong>Appearance:</strong> {appearance}
                    </div>
                  )}
                  <div className="atom_info">
                    <span>Atomic Mass: {atomic_mass} | </span>
                    <span>Density: {density}</span>
                    {molar_heat && <span> | Molar Heat: {molar_heat}</span>}
                    {melt && <span> | Melt: {melt}K</span>}
                    {boil && <span> | Boil: {boil}K</span>}
                  </div>
                  <div>
                    {summary} ...{" "}
                    <a target="_blank" href={source}>
                      Source
                    </a>
                  </div>
                </div>
              </div>
            </Fragment>
          )} */}

          {/* {this.populateElements(5, 57)}
          {this.populateElements(72, 89)}
          {this.populateElements(104, 118)}
          {this.populateElements(58, 71)}
          {this.populateElements(90, 103)} */}
        </div>
        <h3 className="center" style={{ paddingLeft: '30px', marginTop: '20px' }}>
          Quality
        </h3>
      </>
    );
  }
}

export default QualityLayout;
